import { Box, CircularProgress } from "@mui/material";
import React, { useEffect } from "react";
import Slider from "../components/Slidbar/Slidbar";
import TicketDetails from "../components/SupportTickets/TicketDetails";
import { useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  SupportTickets,
  clearTicketDetail,
} from "../app/slices/supportTicketsSlice";

export const SupportTicketView = () => {
  const { id } = useParams();
  const dispatch = useDispatch();

  const {
    ticketDetail: { data, loading },
  } = useSelector((state) => state.supportTickets);

  useEffect(() => {
    if (id) {
      dispatch(SupportTickets.show(id));
    }
    return () => {
      dispatch(clearTicketDetail());
    };
  }, [id, dispatch]);

  if (loading) {
    return (
      <>
        <Slider />
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "50vh",
          }}
        >
          <CircularProgress size={60} />
        </Box>
      </>
    );
  }

  return (
    <>
      <Slider />
      <Box sx={{ ml: -1 }}>
        <TicketDetails data={data} id={id} />
      </Box>
    </>
  );
};

export default SupportTicketView;
